import { EventEmitter } from '@angular/core';

export class NavService {
  navchange: EventEmitter<any> = new EventEmitter();
  constructor() {}
  emitNavChangeEvent(data) {
    this.navchange.emit(data);
  }
  getNavChangeEmitter() {
    return this.navchange;
  }
}
